
const getOptions = (blanksData) => blanksData.get('options');
const getVariableOptions = (blanksData) => blanksData.get('variableOptions');
const getAnswerText = (blanksData) => blanksData.get('answerText');
const getResumedAnswer = (blanksData) => blanksData.get('resumedAnswer');
const isAnswered = (localAnswer) => localAnswer && localAnswer.some(answer => !!answer);

export {getOptions, getAnswerText, getResumedAnswer, isAnswered, getVariableOptions}